import { getCDNAssetURL } from "../../utils/web-helper"
const cdnAssetUrl = getCDNAssetURL();

export const BlobInActiveIcon = `${cdnAssetUrl}/assets/new_onboarding/blob.svg`;
export const BlobActiveIcon = `${cdnAssetUrl}/assets/new_onboarding/blob-active.svg`;
export const ELPIcon = `${cdnAssetUrl}/assets/new_onboarding/ELP.svg`;
export const ESPIcon = `${cdnAssetUrl}/assets/new_onboarding/ESP.svg`;
export const TVContainerImg = `${cdnAssetUrl}/assets/new_onboarding/TVContainer.svg`;
export const LPAge2To5Img = `${cdnAssetUrl}/assets/new_onboarding/loadthrough_screen_2/LP-Age2-5.svg`;
export const LPG1ToG2Img = `${cdnAssetUrl}/assets/new_onboarding/loadthrough_screen_2/LP-G1-G2.svg`;
export const LPG3ToG5Img = `${cdnAssetUrl}/assets/new_onboarding/loadthrough_screen_2/LP-G3-G5.svg`;
